import { render } from "./IllustrationFour.vue?vue&type=template&id=0150e3f2&scoped=true"
import script from "./IllustrationFour.vue?vue&type=script&lang=js"
export * from "./IllustrationFour.vue?vue&type=script&lang=js"

import "./IllustrationFour.vue?vue&type=style&index=0&id=0150e3f2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0150e3f2"]])

export default __exports__